
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.005 18C.452 18 0 18.452 0 19.005v1.567c0 .552.452 1.004 1.005 1.004h21.99c.282 0 .533-.11.714-.29.18-.182.291-.433.291-.714v-1.567c0-.553-.452-1.005-1.005-1.005H1.005zM1.005 10.286C.452 10.286 0 10.738 0 11.29v1.567c0 .553.452 1.005 1.005 1.005h21.99c.282 0 .533-.11.714-.291.18-.181.291-.432.291-.714V11.29c0-.552-.452-1.004-1.005-1.004H1.005zM1.005 2.571C.452 2.571 0 3.023 0 3.576v1.567c0 .553.452 1.005 1.005 1.005h21.99c.282 0 .533-.11.714-.292.18-.18.291-.432.291-.713V3.576c0-.553-.452-1.005-1.005-1.005H1.005z"}})])
          )
        }
      }
    